import { createContext } from 'react';
import { v as bvVar } from 'bv';

const PriceFormatContext = createContext(bvVar('priceFormatId'));

export default PriceFormatContext;
